<form class="form-material m-t-10 row" [formGroup]="questionMatrixForm">
  <div class="form-group col-12 answer-even-input">
    <input
      *ngFor="let item of titlePropertiesArray; let i = index"
      [placeholder]="titlePlaceholderArray[i]"
      [formControlName]="item"
      class="form-control m-b-10"
      [tooltip]="popTemplate"
      [isOpen]="canShowFormControlError(item)"
      container="body"
      #pop="bs-tooltip"
      triggers=""
      placement="bottom"
      containerClass="error-tooltip"
      [id]="item"
      type="text"
    />
  </div>
  <div class="col-6">
    <span>Columns</span>
    <div class="form-group row" *ngFor="let item of columnsPropertiesArray; let i = index">
      <span class="p-t-10">{{ i + 1 }}.</span>
      <div class="col answer-even-input">
        <input
          *ngFor="let langItem of item; let i = index"
          [placeholder]="columnsPlaceholderArray[i]"
          [formControlName]="langItem"
          class="form-control"
          [tooltip]="popTemplate"
          [isOpen]="canShowFormControlError(langItem)"
          container="body"
          #pop="bs-tooltip"
          triggers=""
          placement="bottom"
          containerClass="error-tooltip"
          [id]="langItem"
          type="text"
        />
      </div>
      <div class="btn btn-sm m-t-5" (click)="deleteColsInputGroup(item)">
        <i class="float-right btn btn-sm ti-close"></i>
      </div>
    </div>
  </div>
  <div class="col-6">
    <span>Rows</span>
    <div class="form-group row" *ngFor="let item of rowsPropertiesArray">
      <i class="p-t-10" [ngClass]="getIsMatrixCheckbox() ? 'ti-layout-width-full' : 'fa fa-circle-thin'"></i>
      <div class="col answer-even-input">
        <input
          *ngFor="let langItem of item; let i = index"
          [placeholder]="rowsPlaceholderArray[i]"
          [formControlName]="langItem"
          class="form-control"
          [tooltip]="popTemplate"
          [isOpen]="canShowFormControlError(langItem)"
          container="body"
          #pop="bs-tooltip"
          triggers=""
          placement="bottom"
          containerClass="error-tooltip"
          [id]="langItem"
          type="text"
        />
      </div>
      <div class="btn btn-sm m-t-5" (click)="deleteRowsInputGroup(item)">
        <i class="float-right btn btn-sm ti-close"></i>
      </div>
    </div>
  </div>
</form>
<ng-template #popTemplate>This field is required and must be longer then 1 letter</ng-template>
